import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import List from "../../styledComponents/Table/List";
import FETCH from "../../../utils/fetch";
import { MODULE_API } from "../../../apis";
import menuIcon from "../../../assets/images/DeathModuleNew/Menu.png";
import manageIcon from "../../../assets/images/logoForPlaid.png";
import Loader from "../../../components/styled-components/loader/loader";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import swal from "sweetalert";
import moment from "moment";
import "../AssetsDashboard.css";
import DEATH_API from "../../../apis/death.api";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setRefreshTimeAsset } from "../../../redux/slices/itemsSlice";
import { Table } from "antd";
export const FutureAssetList = (props) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [assetsList, setAssetsList] = useState([]);
  const refreshTime = useSelector(
    (state) => state.rootReducer.itemsInfo.refreshTimeAsset
  );
  const dispatch = useDispatch();

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [cachedData, setCachedData] = useState({});
  const [total, setTotal] = useState(null);

  const report_cols = [
    {
      title: "Asset Type",
      dataIndex: "module",
      sorter: (a, b) =>
        a.module > b.module ? 1 : a.module === b.module ? 0 : -1,
      render: (record) => (record ? record : "--------"),
    },
    {
      title: "Name of Asset",
      dataIndex: "Name of Asset",
      sorter: (a, b) => a["Name of Asset"] > b["Name of Asset"],
      render: (record) => (record ? record : "--------"),
    },
    {
      title: "Account Type",
      dataIndex: "Account Type/Titled",
      key: "account",
      sorter: (a, b) =>
        a["Account Type/Titled"] > b["Account Type/Titled"]
          ? 1
          : a["Account Type/Titled"] === b["Account Type/Titled"]
          ? 0
          : -1,
      render: (record) => (record ? record : "--------"),
    },
    {
      title: "Held Where",
      dataIndex: "Held Where",
      key: "held_where",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Monetary Value",
      dataIndex: "Monetary Value",
      key: "value",
      defaultSortOrder: "descend",
      sorter: (a, b) => a["Monetary Value"] - b["Monetary Value"],

      render: (record) =>
        record ? `$ ${record.toLocaleString("en-US")}` : "--------",
    },
    {
      title: "Value as of Date",
      dataIndex: "Value as of Date",
      key: "value_date",
      render: (record) =>
        record && record ? moment(record).format("MM-DD-YYYY") : "N/A",
    },

    {
      title: "Action",
      render: (record, index) => {
        return (
          <React.Fragment>
            <div style={{ display: "flex" }} key={index}>
              <div
                onClick={() => {
                  getSelectedRow(record.id);
                  setDropdown(!dropdown);
                }}
                style={{
                  cursor: "pointer",
                  marginRight: "1rem",
                  padding: "6px 16px",
                  width: "5px",
                }}>
                <img src={menuIcon} alt="menuIcon" height={15} width={4}></img>
              </div>
              {dropdown && selectedIndex === record.id && (
                <React.Fragment>
                  <div
                    onClick={() => {
                      setDropdown(false);
                    }}
                    className=""
                    style={{
                      position: "fixed",
                      width: "100vw",
                      height: "100vh",
                      background: "black",
                      opacity: "0.1",
                      top: "0",
                      left: "0",
                      right: "0",
                      bottom: "0",
                      zIndex: "999",
                    }}></div>

                  <div class="dropdown" style={{ zIndex: "9999" }}>
                    <ul className="dropdownul">
                      <li
                        className="liHover"
                        onClick={() => {
                          fnView(record);

                          setDropdown(false);
                        }}>
                        View
                      </li>
                      <li
                        className="liHover"
                        // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                        onClick={() => {
                          fnEdit(record);

                          setDropdown(false);
                        }}>
                        Update
                      </li>

                      <li
                        className="liHover"
                        // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                        onClick={() => {
                          setCachedData({});
                          deletePost(record.id, record.managedBy);

                          setDropdown(false);
                        }}>
                        Delete
                      </li>
                    </ul>
                  </div>
                </React.Fragment>
              )}{" "}
              {record.managedBy === "Plaid" && (
                <div className="managed-by-plaid-icon"> </div>

              )}
            </div>
          </React.Fragment>
        );
      },
    },
  ];

  const getAssetsList = async (page) => {
    if (cachedData && cachedData[page]) {
      // Use cached data
      setLoading(false);
      updateStateWithData(cachedData[page]);
      return;
    }
    try {
      setLoading(true);
      let datares = await FETCH.post({
        url: "client-module-service/client-module/future-assets",
        id: `?page=${page}&limit=10`,
        body: {},
      });
      if (datares && datares.records) {
        // setAssetsList(datares.records);
        // Cache the data for the current page
        setCachedData((prevState) => ({
          ...prevState,
          [page]: datares,
        }));
        updateStateWithData(datares);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getAssetsListAfterDelete = async (page) => {
    try {
      setLoading(true);
      let datares = await FETCH.post({
        url: "client-module-service/client-module/future-assets",
        id: `?page=${page}&limit=10`,
        body: {},
      });
      if (datares && datares.records) {
        // setAssetsList(datares.records);
        // Cache the data for the current page
        setCachedData((prevState) => ({
          ...prevState,
          [page]: datares,
        }));
        updateStateWithData(datares);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const updateStateWithData = (datares) => {
    if (datares && datares.records) {
      console.log("future asset", datares.pagination.total);
      setAssetsList(datares.records);
    }
    if (datares && datares.pagination) {
      setTotal(datares.pagination.total);
      setTotalPages(
        Math.ceil(datares.pagination.total / datares.pagination.limit)
      );
    }
  };

  const deleteLinkTransactions = async (id) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete [asset/liability]? All Transactions in Budget will be deleted as well.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          setLoading(true);
          let payload = {
            cmId: id,
          };
          const resposnse = await DEATH_API.deleteLinkTransactions(payload);
          if (resposnse && resposnse.status === 200) {
            swal("Success", resposnse.message, "success");
          }
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
      } else {
        swal("Cancelled", "Your Transactions are safe :)", "error");
      }
    });
  };
  const deletePost = async (id, managedBy) => {
    console.log("delete is", id);
    swal({
      title: "Are you sure?",
      text: "You want to delete this?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (result) => {
      if (result === true) {
        setLoading(true);
        try {
          const res = await MODULE_API.removeClientModule({
            clientModules: [id],
          });
          if (res && res.status === 200 && managedBy === "Plaid") {
            deleteLinkTransactions(id);
          }
          setAssetsList([]);
          props.updateSharedState(!props.sharedState);
          getAllAssets();
          // return res;
        } catch (error) {
          setLoading(false);
        }
      }
    });
  };
  const fnEdit = (record) => {
    history.push(`/assets_new/attributes/${record.module}/${record.id}`);
  };
  const fnView = (record) => {
    history.push(`/assets_new/attributes/${record.module}/${record.id}/view`);
  };
  useEffect(() => {
    getAllAssets(currentPage);
  }, [currentPage]);

  const getAllAssets = async (currentPage) => {
    setAssetsList([]);
    if (currentPage) {
      await getAssetsList(currentPage);
    } else {
      setCachedData({});
      await getAssetsListAfterDelete(1);
    }
  };
  const getSelectedRow = (id) => {
    setSelectedIndex(id);
  };

  return (
    <div style={{ position: "relative" }}>
      <h3 className="incomecardheading">Future Asset Details</h3>
      <Table
        columns={report_cols}
        dataSource={assetsList && assetsList}
        pagination={{
          total: totalPages * 10, // Assuming 10 items per page
          current: currentPage,
          onChange: (page) => {
            setCurrentPage(page);
          },
          pageSize: 10, // Number of items per page
        }}
      />
      <NewLoader isLoading={loading} />
    </div>
  );
};
